const IssuesData1 = [
    {
        img: '/Images/issues1.png',
        name: 'Whispers in the Hills',
        content: 'In the shadow of Kalimpong and Darjeeling’s beauty lies silent suffering—tea gardens closed, employment opportunities scarce with no big factories, and hope fading with every landslide and quake. Women, children, and youth, unaware of their basic rights lived a life with no dignity until the late Binay Khati ji founded Hill Social Welfare, to turnaround their lives. Empowering communities with an enabling environment for sustainable development.',
        icon: 'ti-arrow-right',
        linkTitle: "Read More",
        name1:'Hill Social Welfare Society',
        link:'/GSN-5091/HSWS',
        id:'Causes'

    },
    {
        img: '/Images/issues2.jpg',
        name: 'Breaking barriers, turning Courage into Capital',
        content: 'How do you empower rural women with no collateral, poor access to banks and deep-rooted patriarchy that limits their freedom and financial choices? Low literacy and a wide digital gap makes learning and banking even harder. Add to that, the challenges of remote locations and limited market access. Mann Deshi launched in the Mann block, Satara, Maharashtra, India’s first women-run rural bank, mobile business schools and community radio with strong market linkages. Breaking social and structural barriers, using their courage to help 1 million women become financially independent and confident entrepreneurs!',
        icon: 'ti-arrow-right',
        linkTitle: "Read More",
        name1:'Mann Deshi Foundation',
        link:'/GSN-1049/MannDeshi',
        id:'Causes'
    },
    {
        img: '/Images/issues3.png',
        name: 'Opening doors for locked up special children',
        content: 'It was an eye-opening visit to the home of a 13-year-old girl with intellectual disability that was the seed for Satya Special School. When founder, Chitra Shah, went to her house to know why she had missed her doctor’s appointment, what she saw shocked her: the girl was tied to a chair in her locked house, as her single mother had to leave for work. What was more shocking was that this was not an isolated case, and was but a symptom of the extreme exclusion of people with disabilities. Along with other like-minded people, Chitra started Satya Special School in 2003 to give children with developmental disabilities an opportunity to live with dignity.',
        icon: 'ti-arrow-right',
        linkTitle: "Read More",
        name1:'Satya Special School ',
        link:'/GSN-1645/SSS',
        id:'Causes'
    },
]


export { IssuesData1 }